import axios from 'axios';

export default class AiSettingsService
{
    public static async getSettings()
    {
        return (await axios.get<AiSettings>('admin/ai/settings')).data;
    }
}
